import gql from "graphql-tag"
import partialUser from "@irati/identity/services/fragments/PartialUser"
import fullUserV4 from "@irati/identity/services/fragments/fullUserV4"

const fragment = gql`
  fragment ScheduledRecognition on SchedulerEvent {
    uuid
    businessId
    originalTimezone
    when
    status
    createdBy {
      ...partialUser
    }
    metadata {
      createdAt
    }
    payload {
      publishRecognition {
        occasionId
        companyValueIds
        message
        occasionId
        receiverIds
        rewardAmount
        visibility
        occasion {
          uuid
          name
          tag
          default
          icon {
            href
            alt
          }
          archived
        }
        companyValues {
          archived
          name
          tag
          uuid
          icon {
            href
            alt
          }
        }
        receivers {
          ...fullUser
        }
        budget {
          categoryId
          useUnassigned
        }
      }
    }
  }
  ${fullUserV4}
  ${partialUser}
`

export default fragment
